import React from 'react';
import { Footer } from 'components/footer';
import sealinkLogo from 'assets/images/sealink-logo.png';

export default function MaintenancePage() {
  return (
    <>
      <div className="container maintenance-page">
        <img className="header-logo-sealink" src={sealinkLogo} alt="SeaLink" />
        <h1>Planned website maintenance</h1>
        <p>
          Due to scheduled website maintenance between 10.30pm Monday 28
          September and 4.30am, Tuesday 29 September, bookings will be
          unavailable.
        </p>
        <p>Thank you for your understanding.</p>
      </div>
      <Footer />
    </>
  );
}
